<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>Good to see you again!</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
      <mat-form-field appearance="outline">
        <mat-label>Username</mat-label>

        <input
          matInput
          type="text"
          formControlName="user"
          placeholder="Enter your username"
          autocomplete="username"
        />

        @if (loginForm.get('user')?.hasError('required')) {
          <mat-error> Username is required </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>

        <input
          matInput
          type="password"
          formControlName="password"
          placeholder="Enter your password"
          autocomplete="current-password"
        />

        @if (loginForm.get('password')?.hasError('required')) {
          <mat-error> Password is required </mat-error>
        }
      </mat-form-field>

      <button matButton="filled" color="primary" type="submit" [disabled]="loginForm.invalid">
        Login
      </button>
    </form>
  </mat-card-content>
</mat-card>
